/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-12-15 20:13:52
 * @LastEditors: shenlin
 * @LastEditTime: 2022-04-28 17:12:49
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业认证列表页列表
export const listCheckByPage = params => request(BASE_URL + '/govEntIntermediary/listCheckByPage', { params })
